import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import {
  getEProfile,
  getEProfileVariables,
} from '../../../../models/graphqlTypes'
import { GET_E_PROFILE } from '../../../../operations/patientEProfileOperations'
import { DoctorPatientRouteParams } from '../types/doctorPatients.types'

export type PatientDetail = getEProfile['getEProfile']

export type UsePatientEProfileReturn = {
  isLoading: boolean
  patientDetails: PatientDetail
  isEditable: boolean
}

export const usePatientEProfile = (): UsePatientEProfileReturn => {
  const { patientId } = useParams<DoctorPatientRouteParams>()

  const { data, loading } = useQuery<getEProfile, getEProfileVariables>(
    GET_E_PROFILE,
    {
      variables: {
        patientId: patientId ?? '',
      },
      skip: !patientId,
    }
  )

  const patientDetails = data?.getEProfile ?? {
    __typename: 'PatientEProfile',
    patientId: '',
    warnings: [],
    lifestyle: { __typename: 'LifeStyleGroup', lastUpdated: new Date() },
    cases: [],
    medications: [],
    vaccinations: [],
    surgeries: [],
  }

  return {
    patientDetails,
    isLoading: loading,
    isEditable: false,
  }
}
